import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrdersState } from '../../models/orders-state.model';

export const selectOrdersState = createFeatureSelector<OrdersState>('orders');

export const selectOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.orders
);

export const selectOrder = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.order
);

export const selectIsLoading = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.isLoading
);

export const selectPagedOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.orders
);

export const selectManualPagedOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.manualOrders
);

export const selectPendingPagedOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.pendingOrders
);

export const selectInProgressPagedOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.inProgressOrders
);

export const selectFinishedPagedOrders = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.finishedOrders
);

export const selectFinishedPagedOrdersWithCashToCollect = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.finishedOrdersWithCashToCollect
);


export const selectTotalItems = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.totalItems
);

export const selectTotalPages = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.totalPages
);

export const selectCurrentOrder = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.selectedOrder
);

export const selectCalculatedRoute = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.calculatedOrderRoute
);

export const selectOrderById = (id: number) => createSelector(
  selectOrdersState,
  (state: OrdersState) => {
    // Buscar en `orders`
    let order = state.orders.find(order => order.id === id);

    // Si no está en `orders`, buscar en `manualOrders`
    if (!order) {
      order = state.manualOrders.find(order => order.id === id);
    }

    // Retornar la orden encontrada o `undefined` si no existe
    return order;
  }
);

export const selectCurrentOrderId = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.selectedOrderId
);

export const selectSearchOrderById = (id: number) => createSelector(
    selectOrdersState,
    (state: OrdersState) => {
      const order = state.orders.find(order => order.id === id);
      return order ? [order] : [];
    }
  );

export const selectSelectedOrder = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.selectedOrder
  );

export const selectVehicleTypes = createSelector(
    selectOrdersState,
    (state: OrdersState) => state.vehicleTypes
);

